// Reusable validation utilities for partners page

/**
 * Validates that a string is either empty/undefined or a valid comma-separated list.
 * Each element in the list should not contain spaces after trimming.
 */
export function validateCsv(value) {
  if (value == null) return true
  const trimmed = String(value).trim()
  if (trimmed.length === 0) return true

  return trimmed
    .split(',')
    .map(part => part.trim())
    .every(part => part.length > 0 && !part.includes(' '))
}
